export const getStrategies = (state) => {
  return state.strategies;
};
export const getStrategiesMsg = (state) => {
  return state.strategies_msg;
};
export const getInvestment = (state) => {
  return state.investment;
};
